'use client';
/**
 * L'EN-TÊTE D'ÉCRAN — une seule forme, pour les cinquante-cinq écrans.
 * ──────────────────────────────────────────────────────────────────────────
 *
 * ── Ce qu'il ferme (relevé SYS-1 du 26/08/2026) ─────────────────────────────
 *
 * « Cinq en-têtes de page différents » : chapeau + pastille ISO, chapeau · ISO
 * + pastille, chapeau · ISO sans pastille, ISO · chapeau sans pastille, et
 * aucun en-tête du tout.
 *
 * ⚠️ Le composant, lui, était DÉJÀ unique — `H1` n'est qu'un alias de
 * `TitrePage`. Ce qui divergeait n'était pas le composant mais la façon dont
 * chaque écran COMPOSAIT son chapeau à la main, en JSX, cinquante-cinq fois.
 * Ajouter un sixième composant n'aurait rien réglé ; ce qui manquait, c'est
 * que la RÈGLE de composition vive quelque part.
 *
 * La forme retenue, et la seule :
 *
 *     RUBRIQUE · §X.Y
 *
 * — la rubrique d'abord (c'est la famille du menu, donc ce qui situe), la
 * clause ensuite : pastille puis texte de la norme, dans cet ordre.
 *
 * ── Deux invariants ─────────────────────────────────────────────────────────
 *
 *  1. **Une seule clause, citée une seule fois.** La pastille et le texte
 *     reçoivent le MÊME code, puisqu'il n'y a qu'un paramètre. Composés à la
 *     main, rien n'empêchait la pastille d'annoncer §8.6 et le texte d'ouvrir
 *     §7.7 : l'écran aurait montré une clause et ouvert l'autre. Vérifié le
 *     27/08 — aucun écart n'existait, mais rien ne l'interdisait.
 *  2. **La clause est FACULTATIVE, et son absence n'est pas un oubli.** Les
 *     huit écrans « Plannings & RH » ne relèvent d'aucune clause de la 15189.
 *     En exiger une partout obligerait à en inventer, ce qui est pire que de
 *     n'en citer aucune.
 */
import React from 'react';
import { TitrePage, RefISO } from '@/components/ui';
import { Norme } from '@/components/Norme';

export function EnteteEcran({ rubrique, clauseISO, titre, sousTitre, actions }: {
  /** La famille du menu — « Ressources », « Écoute patient », « Plannings & RH ». */
  rubrique: React.ReactNode;
  /** La clause ISO 15189, quand l'écran en relève une. */
  clauseISO?: string;
  titre: React.ReactNode;
  sousTitre?: React.ReactNode;
  actions?: React.ReactNode;
}) {
  return (
    <TitrePage
      eyebrow={<>{rubrique}{clauseISO ? <> · <RefISO code={clauseISO} /><Norme art={clauseISO} /></> : null}</>}
      titre={titre}
      sousTitre={sousTitre}
      actions={actions}
    />
  );
}
